<template src="./relationships.html"></template>

<script>
import _ from 'lodash'
import { ChiRhosNext } from '@paladin/core'
import { PaladinTypeahead } from '@paladin/core-components'

const ChiRhosNextApi = new ChiRhosNext().api();

//import PaladinTypeahead from '../../../components/typeahead/paladin-typeahead'

import {
  PersonApi,
  RelationshipApi,
  RelationshipTypeApi,
  ApiRequest,
  ApiEntityRequest,
  ApiSearchPagedRequest,
  RelationshipConstruct,
} from '@chirhos/chirhos-api'
import { ChiRhos } from '@paladin/core'

let ChiRhosApi = new ChiRhos().api()

var personApi = new PersonApi(ChiRhosApi)
var relationshipApi = new RelationshipApi(ChiRhosApi)
var relationshipTypeApi = new RelationshipTypeApi(ChiRhosApi)

export default {
  page() {
    return {
      title: 'People | Relationships',
    }
  },
  components: {
    PaladinTypeahead,
  },
  props: {
    identity: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    // people: {
    //   type: Array,
    //   required: true,
    // },
  },
  data() {
    return {
      query: '',
      users: [],
      selectedFromUser: null,
      selectedToUser: null,
      selectedRelationshipDescription: '',
      addRelationshipForm: {
        type: null,
        selection: null,
      },
      relationshipTypes: null,
      relationships: [],
    }
  },
  computed: {
    // Relationship Type options for the dropdown
    relationshipTypeOptions: function() {
      if (this.relationshipTypes) {
        var reducedArray = [].concat
          .apply(
            this.relationshipTypes.map((item) => {
              return {
                value: item.entity.entityId + '_fwd',
                text: `${item.entity.forwardsDescription} (to ${
                  item.entity.reverseDescription
                })`,
              }
            }),
            this.relationshipTypes.map((item) => {
              return {
                value: item.entity.entityId + '_rev',
                text: `${item.entity.reverseDescription} (to ${
                  item.entity.forwardsDescription
                })`,
              }
            })
          )
          .sort((a, b) => (a.value > b.value ? 1 : b.value > a.value ? -1 : 0))

        return reducedArray
      } else {
        return null
      }
    },
    relationshipTypeOptionsMapping: function() {
      if (this.relationshipTypes) {
        var _combinedArray = [].concat.apply(
          this.relationshipTypes.map((item) => {
            return {
              value: item.entity.entityId + '_fwd',
              text: item.entity.forwardsDescription,
              entity: item.entity,
              options: {
                direction: 'fwd',
                values: this.relationshipTypes
                  .filter(
                    (e) =>
                      e.entity.forwardsDescription ===
                      item.entity.forwardsDescription
                  )
                  .map((option) => {
                    return {
                      value: option.entity.entityId,
                      text: option.entity.reverseDescription,
                      entity: option.entity,
                    }
                  }),
              },
            }
          }),
          this.relationshipTypes.map((item) => {
            return {
              value: item.entity.entityId + '_rev',
              text: item.entity.reverseDescription,
              entity: item.entity,
              options: {
                direction: 'rev',
                values: this.relationshipTypes
                  .filter(
                    (e) =>
                      e.entity.forwardsDescription ===
                      item.entity.forwardsDescription
                  )
                  .map((option) => {
                    return {
                      value: option.entity.entityId,
                      text: option.entity.forwardsDescription,
                      entity: option.entity,
                    }
                  }),
              },
            }
          })
        )

        let _reducedArray = _combinedArray
          .map((e) => e.text)

          // store the keys of the unique objects
          .map((e, i, final) => final.indexOf(e) === i && i)

          // eliminate the duplicate keys & store unique objects
          .filter((e) => _combinedArray[e])
          .map((e) => _combinedArray[e])

        // let _return = this.relationshipTypes.map((item) => {
        //   return {
        //     value: item.entity.entityId + '_fwd',
        //     text: `${item.entity.forwardsDescription}`,
        //   }
        // })
        // console.log(_return)
        // return _return
        return _reducedArray
      } else {
        return null
      }
    },
    approvedRelationships: function() {
      if (this.relationships && this.relationships.length > 0) {
        return this.relationships.filter((item) => {
          return (
            item.container.relationship.entity.acceptedFrom &&
            item.container.relationship.entity.acceptedTo
          )
        })
      } else {
        return null
      }
    },
    pendingRelationships: function() {
      if (this.relationships && this.relationships.length > 0) {
        return this.relationships.filter((item) => {
          return (
            !item.container.relationship.entity.acceptedFrom ||
            !item.container.relationship.entity.acceptedTo
          )
        })
      } else {
        return null
      }
    },
  },
  watch: {
    // When the query value changes, fetch new results from
    // the API - debounce the search to avoid hitting the API limits
    query: function(/*newQuery, oldQuery*/) {
      this.debouncedSearchPeople()
    },
  },
  mounted() {
    // console.log(this.user)
    this.getRelationshipTypes()
  },
  created: function() {
    this.debouncedSearchPeople = _.debounce(this.searchPeople, 500)
  },
  methods: {
    searchPeople() {
      if (this.query && this.query.length >= 3) {
        personApi
          .Lookup({
            request: new ApiSearchPagedRequest(this.query, 1, 100, false),
          })
          .then(
            (response) => {
              // console.log(response.data)
              this.users = response.data
            },
            (error) => {
              console.error(error)
              this.$toast(error, 'error')
            }
          )
      }
    },
    getRelationshipTypes() {
      relationshipTypeApi
        .List({
          request: new ApiRequest(),
        })
        .then(
          (response) => {
            // console.log(response.data)
            this.relationshipTypes = response.data
            this.getRelationships()
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
    },
    // getRelationshipType(entityId) {
    //   var promise = new Promise(function(resolve, reject) {
    //     return relationshipApi
    //       .GetRelationship({
    //         request: new ApiEntityRequest(entityId),
    //       })
    //       .then(
    //         function(response) {
    //           resolve(response.data)
    //         },
    //         function(error) {
    //           reject(error)
    //         }
    //       )
    //   })

    //   return promise
    // },
    getPerson(entityId) {
      var promise = new Promise(function(resolve, reject) {
        return personApi
          .Get({
            request: new ApiEntityRequest(entityId),
          })
          .then(
            function(response) {
              resolve(response.data)
            },
            function(error) {
              reject(error)
            }
          )
      })

      return promise
    },
    getRelationships() {
      this.relationships = []
      relationshipApi
        .ListForPerson({
          request: new ApiEntityRequest(this.user.profile.entityId),
        })
        .then(
          (response) => {
            return response.data
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
        .then(
          (response) => {
            response.map((item) => {
              var _typePromise = this.relationshipTypes.find(function(obj) {
                return obj.entity.entityId === item.relationship.entity.type
              })

              // console.log(_typePromise)
              var _fromPromise = this.getPerson(item.relationship.entity.from)
              var _toPromise = this.getPerson(item.relationship.entity.to)

              var _relationships = this.relationships
              Promise.all([_typePromise, _fromPromise, _toPromise]).then(
                function(values) {
                  _relationships.push({
                    container: item,
                    type: values[0],
                    from: values[1],
                    to: values[2],
                  })
                }
              )
              // console.log(_relationships)
              this.relationships = _relationships
            })
            // console.log(_data)
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
    },
    acceptRelationship(relationsipEntityId) {
      relationshipApi
        .Accept({
          value: relationsipEntityId,
        })
        .then(
          (/*response*/) => {
            // console.log(response.data)
            // this.users = response.data

            this.$toast('Relationship accepted!', 'success')
            // refresh
            this.getRelationships()
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
    },
    newRelationshipSubmit(evt) {
      evt.preventDefault()

      var _relationshipTypeEntityId = this.addRelationshipForm.selection

      var _from = this.selectedFromUser.entityId
      var _to = this.selectedToUser.entityId

      // if (_type[1] === 'rev') {
      //   _from = this.selectedToUser.entityId
      //   _to = this.selectedFromUser.entityId
      // }

      relationshipApi
        .Save({
          value: new RelationshipConstruct(
            _relationshipTypeEntityId,
            _from,
            _to
          ),
        })
        .then(
          (/*response*/) => {
            // console.log(response.data)
            // this.users = response.data
            this.$toast('New relationship created', 'success')
            this.getRelationships()
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
    },
    relationshipTypeSelected(evt) {
      // console.log(evt)
      if (evt && evt.values && evt.values.length > 0) {
        this.addRelationshipForm.selection = evt.values[0].entity.entityId
        // console.log(evt.values[0])
        this.selectedRelationshipDescription = evt.values[0].text
      }
    },
  },
}
</script>
